import { Theme } from '@emotion/react';

export const theme: Theme = {
  colors: {
    SurfaceIndependence40: '#2D2D47',
    SurfaceCultured10: '#F4F4F5',
    SurfacePlatinum20: '#EAEAEC',
    SurfaceRomanSilver30: '#8F8E99',
    SurfaceRaisinBlack50: '#1A1A29',
    SurfaceRichBlack60: '#0A0A0B',
    SurfaceWhite: '#FFFFFF',
    SurfaceSpaceCadet50: '#23233B',

    error: '#FF7061',
    submit: '#57CD9C',
    // Предупреждение. Читаем только на тёмных поверхностях (7.06:1 на Black24,
    // 7.81:1 на SurfaceRaisinBlack50). На белом даёт 2.20:1 — текстом на светлом
    // фоне не использовать, там нужен тёмный оттенок из шкалы DarkYellow.
    warning: '#FF9500',

    // Исходы заявки. У каждого тона четыре роли: базовый цвет (граница и ховер),
    // светлая заливка неактивного чипа, насыщенная — активного, и тёмный текст.
    // Базы — существующие цвета темы: CaseSuccess === submit, CaseError === error,
    // CasePending === AccentNaplesYellow; оттенки выведены из них, чтобы три тона
    // читались как одна шкала. Контраст текста: на своей светлой заливке 5.4–5.7:1,
    // на насыщенной 4.6–4.8:1.
    CaseSuccess: '#57CD9C',
    CaseSuccessSurface: '#E7F8F1',
    CaseSuccessSurfaceActive: '#C6EEDD',
    CaseSuccessText: '#2F6F54',

    CaseError: '#FF7061',
    CaseErrorSurface: '#FFEBE9',
    CaseErrorSurfaceActive: '#FFCEC9',
    CaseErrorText: '#99433A',

    CasePending: '#D9B244',
    CasePendingSurface: '#FAF4E5',
    CasePendingSurfaceActive: '#F2E5BF',
    CasePendingText: '#756025',

    AccentNaplesYellow: '#D9B244',
    AccentMediumChampagne: '#FAECAB',
    AccentJonquil: '#F2CA18',
    AccentCornsilk: '#FFF8D9',

    DarkYellow: '#D9B244',
    DarkYellow100: '#F8EDC5',
    DarkYellow200: '#F0D88F',
    DarkYellow300: '#E6C662',
    DarkYellow400: '#DBB749',
    DarkYellow600: '#B89638',
    DarkYellow700: '#94762D',
    DarkYellow800: '#705622',
    DarkYellow900: '#4C3716',

    DarkYellowAlpha80: '#D9B244CC',
    DarkYellowAlpha60: '#D9B24499',
    DarkYellowAlpha40: '#D9B24466',
    DarkYellowAlpha20: '#D9B24433',

    LightGold: '#E8D18F',
    Gold: '#E1C169',

    WhiteGray: '#9093AA',
    WhiteGray60: '#9093AA99',
    WhiteGray50: '#9093AA80',
    WhiteGray20: '#9093AA33',
    WhiteGray10: '#9093AA1A',

    BorderGray50: '#F7F8FA',
    DisabledInputColor: '#b5b5b7',
    GrayF2: '#F2F2F2',
    Gray96: '#969696',
    // Тёмно-серый для второстепенного текста. Имени в дизайне нет — назван по
    // существующей конвенции (Gray96 = #969696, GrayF2 = #F2F2F2).
    Gray52: '#52525B',
    Black24: '#242424',
    DarkBlue: '#1A1A29',
    DarkBlue100: '#E7E7EC',
    DarkBlue200: '#C2C2D0',
    DarkBlue300: '#9D9DB4',
    DarkBlue400: '#3A3A50',
    DarkBlue600: '#161624',
    DarkBlue700: '#12121F',
    DarkBlue800: '#0E0E1A',
    DarkBlue900: '#0A0A14',

    Blue: '#212738',
    Gray: '#686A79',
    Pink: '#FF2D55',
    Green: '#44D968',
    Black: '#1E1E1E',
    LightBlue: '#008CEA',
    EditorAccentBlue: '#007AFF',
    NarcissusYellow: '#DBB400',
    AlphaWhite: '#FFFFFF99',
    Red: '#FA2427',
  },
  fonts: {
    'caption-1': {
      'font-size': '12px',
      'font-weight': 'normal',
      'font-family': 'SF Pro Text, SF Pro Display, sans-serif',
    },
  },
};
